module.exports = __webpack_public_path__ + "static/img/5-Offshore-wind-farms.b2cf11e4.jpg";